import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Button, CircularProgressIndicator, DescriptionList, Details, Surface, SurfaceButton, Text, useTheme, } from '@talismn/ui';
import {} from 'react';
export const DEX_FORM_WIDE_MEDIA_SELECTOR = `@media(min-width: 76rem)`;
export const TokenSelect = Object.assign((props) => (_jsx("div", { css: { minWidth: '11rem' }, children: _jsx(SurfaceButton, { leadingIcon: 'icon' in props ? props.icon : _jsx("img", { src: props.iconSrc, css: { width: '2.4rem', height: '2.4rem' } }), onClick: props.onClick, css: { width: '100%', padding: '0.5rem 0.8rem' }, children: _jsxs("div", { css: { textAlign: 'start' }, children: [_jsx(Text.BodySmall, { as: "div", alpha: "high", children: props.name }), _jsx(Text.BodySmall, { as: "div", children: props.chain })] }) }) })), {
    Skeleton: () => (_jsx(TokenSelect, { name: "...", chain: "...", icon: _jsx(CircularProgressIndicator, { size: "2.4rem" }), onClick: () => { } })),
});
export const DexFormInfoNotice = (props) => {
    const theme = useTheme();
    return (_jsxs("article", { css: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '0.8rem',
            border: `1px solid color-mix(in srgb, ${theme.color.outlineVariant}, transparent 60%)`,
            borderRadius: '0.8rem',
            padding: '1.6rem',
            textAlign: 'center',
        }, children: [props.illustration, _jsx(Text.BodyLarge, { as: "header", alpha: "high", children: props.title }), _jsx(Text.Body, { children: props.text })] }));
};
export const DexFormInfoProgressIndicator = (props) => (_jsxs("article", { css: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '0.8rem',
        borderRadius: '0.8rem',
        padding: '7.2rem 1.6rem',
        textAlign: 'center',
    }, children: [_jsx(CircularProgressIndicator, { size: "3.2rem" }), _jsx(Text.BodyLarge, { as: "header", alpha: "high", children: props.title }), _jsx(Text.Body, { alpha: "disabled", children: props.text })] }));
const Info = Object.assign((props) => {
    const theme = useTheme();
    return (_jsx("section", { css: {
            display: 'flex',
            flexDirection: 'column',
            border: `2px solid ${theme.color.outlineVariant}`,
            borderRadius: '1.2rem',
            padding: '1.6rem',
            [DEX_FORM_WIDE_MEDIA_SELECTOR]: {
                width: '40rem',
                borderLeft: `64px solid transparent`,
                borderRadius: '0 1.2rem 1.2rem 0',
                '> div': {
                    marginLeft: '-64px',
                },
            },
        }, children: _jsxs("div", { css: { flex: 1, display: 'flex', flexDirection: 'column', gap: '1.6rem' }, children: [props.header, _jsx("div", { css: {
                        display: 'contents',
                        flex: 1,
                        overflow: 'auto',
                        [DEX_FORM_WIDE_MEDIA_SELECTOR]: { display: 'revert' },
                    }, children: _jsx("div", { css: {
                            display: 'contents',
                            height: 0,
                            minHeight: '100%',
                            [DEX_FORM_WIDE_MEDIA_SELECTOR]: { display: 'revert' },
                        }, children: props.children }) }), props.footer] }) }));
}, {
    DescriptionList: Object.assign((props) => _jsx(DescriptionList, { emphasis: "details", children: props.children }), {
        Description: (props) => (_jsxs(DescriptionList.Description, { children: [_jsx(DescriptionList.Term, { children: props.term }), _jsx(DescriptionList.Details, { children: props.details })] })),
    }),
    Faq: Object.assign((props) => (_jsxs("section", { css: { display: 'flex', flexDirection: 'column', gap: '0.8rem' }, children: [props.children, props.footer] })), {
        Question: (props) => (_jsxs(Details, { children: [_jsx(Details.Summary, { children: props.question }), _jsx(Details.Content, { children: props.answer })] })),
        Footer: (props) => (_jsxs(Text.Body, { alpha: "disabled", css: { textAlign: 'center', marginTop: '2.4rem' }, children: ["Still need help? Reach out to us on our", ' ', _jsx(Text, { as: "a", alpha: "high", href: props.discordUrl, target: "_blank", css: theme => ({ color: theme.color.primary, whiteSpace: 'nowrap' }), children: "Discord channel" }), "."] })),
    }),
    Header: (props) => (_jsx("header", { css: { display: 'flex', justifyContent: 'end', alignItems: 'center' }, children: props.actions })),
    Footer: (props) => _jsx(Text.BodySmall, { alpha: "disabled", ...props, css: { textAlign: 'center' } }),
});
const DexForm = Object.assign((props) => {
    return (_jsxs("div", { css: {
            display: 'flex',
            flexDirection: 'column',
            gap: '1.6rem',
            width: 'min(50rem, 100%)',
            [DEX_FORM_WIDE_MEDIA_SELECTOR]: {
                flexDirection: 'row',
                gap: 0,
                width: 'revert',
            },
        }, children: [_jsx("section", { css: {
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '0.8rem',
                    [DEX_FORM_WIDE_MEDIA_SELECTOR]: { width: '50rem' },
                }, children: props.children }), props.info] }));
}, {
    Section: (props) => (_jsxs(Surface, { css: { borderRadius: '1.6rem', padding: '1.6rem' }, children: [_jsx("header", { css: { marginBottom: '0.8rem' }, children: _jsx(Text.H4, { children: props.header }) }), props.children] })),
    CollapsibleSection: (props) => (_jsxs(Details, { css: { padding: '1.6rem' }, open: props.open, disabled: props.disabled, children: [_jsx(Details.Summary, { children: _jsx(Text.H4, { children: props.header }) }), _jsx(Details.Content, { children: props.children })] })),
    ConfirmButton: (props) => _jsx(Button, { ...props, css: { width: '100%' } }),
    Info,
});
export default DexForm;
//# sourceMappingURL=index.js.map